<script setup lang="ts">
import type { BlogPost } from "@/schemas/blog";

defineProps<{ post: BlogPost }>();
</script>

<template>
  <div class="flex flex-col gap-8 lg:flex-row lg:even:flex-row-reverse">
    <a :href="post.permalink" class="w-full shrink-0 overflow-hidden lg:w-1/3">
      <img :src="post.image_url" class="object-cover transition hover:scale-110 lg:h-full">
    </a>
    <div class="flex flex-1 flex-col items-start gap-4">
      <div class="">
        <a :href="post.permalink" class="link-orange">
          <h2 class="h2" v-html="post.title" />
        </a>
        <div>{{ post.date_modified }}</div>
      </div>
      <div class="prose mb-16" v-html="post.excerpt.trim()" />
      <a :href="post.permalink" class="btn-outline-orange">Lire la suite</a>
    </div>
  </div>
</template>
